import React, { memo } from 'react';
import AlertIcon from '../../assets/icons/alert.svg';
import './fallback-ui.scss';
/**
 * A fallback component used to handle the error title and message.
 */
var FallbackUI = function (_a) {
    var errorTitle = _a.errorTitle, errorMessage = _a.errorMessage;
    return (React.createElement("div", { className: "tfm-fallback-ui" },
        React.createElement("div", { className: "tfm-fallback-ui-header" },
            React.createElement("div", { className: "tfm-fallback-ui-header-title" },
                React.createElement(AlertIcon, { className: "tfm-fallback-ui-header-title-icon" }),
                React.createElement("h1", null, "Oops, something went wrong:")),
            React.createElement("h2", null, errorTitle)),
        React.createElement("p", null, errorMessage)));
};
FallbackUI.defaultProps = {
    errorTitle: '',
    errorMessage: '',
};
export default memo(FallbackUI);
